/**
 * @generated SignedSource<<99669e422173f5f0997134b701bd3df7>>
 * @relayHash 0446928955970b59719768048eafdff2
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/548.0.0-2026-02-19T00:31:29.487Z/sourceAttributionMutation

import { ConcreteRequest } from 'relay-runtime';
export type SourceAttributionInput = {
  clientMutationId?: string | null;
  emailToken?: string | null;
  guestUserId?: string | null;
  landingPage?: string | null;
  pageVisits?: ReadonlyArray<pageVisits | null> | null;
  type: string;
  userId: string;
  userToken?: string | null;
  visitCount?: number | null;
};
export type pageVisits = {
  date?: string | null;
  type?: string | null;
  utmParams?: utmParams | null;
};
export type utmParams = {
  landingPage?: string | null;
  visitCount?: number | null;
};
export type sourceAttributionMutation$variables = {
  input: SourceAttributionInput;
};
export type sourceAttributionMutation$data = {
  readonly sourceAttribution: {
    readonly message: string | null;
  } | null;
};
export type sourceAttributionMutation = {
  response: sourceAttributionMutation$data;
  variables: sourceAttributionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SourceAttributionPayload",
    "kind": "LinkedField",
    "name": "sourceAttribution",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sourceAttributionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sourceAttributionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/548.0.0-2026-02-19T00:31:29.487Z/sourceAttributionMutation",
    "metadata": {},
    "name": "sourceAttributionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0776fc099f129d46b7995c62aa8613ee";

export default node;
